<template>
  <div
    class="align-center background-color-white d-flex flex-column py-10 px-7"
  >
    <div class="font-size-lg font-weight-semibold mb-5 text-center">
      Reset Password
    </div>
    <v-form ref="form" v-model="valid" class="full-width">
      <PasswordInput
        :label="'Password (Min. 6 Characters)'"
        :password="password"
        :update="update"
      />
      <ConfirmPasswordInput
        :label="'Confirm Password (Min. 6 Characters)'"
        :confirmPassword="confirmPassword"
        :password="password"
        :update="update"
      />
      <v-btn
        color="success"
        :disabled="!valid"
        @click.stop.prevent="resetPassword"
        block
        large
        rounded
      >
        <div class="font-size-md font-weight-semibold text-capitalize">
          submit
        </div>
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import ConfirmPasswordInput from "@/components/Inputs/ConfirmPassword.vue";
import PasswordInput from "@/components/Inputs/Password.vue";

export default {
  name: "ResetPassword",
  components: { ConfirmPasswordInput, PasswordInput },
  data() {
    return {
      confirmPassword: null,
      password: null,
      valid: true,
    };
  },
  methods: {
    async resetPassword() {
      this.$refs.form.validate();
      if (!this.valid) {
        return;
      }
      await this.$store.dispatch("auth/restorePassword", {
        password: this.password,
        token: this.$route.params.token,
      });
      this.route();
    },
    route() {
      this.to
        ? this.to("login")
        : this.$router.push({ name: "login", params: { from: "reset" } });
    },
    update(name, val) {
      this[name] = val;
    },
  },
  props: {
    to: Function,
  },
};
</script>
